'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.groupByBinary = exports.makeMomentSorter = exports.toArray = undefined;

var _identity = require('lodash/identity');

var _identity2 = _interopRequireDefault(_identity);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Converts a value to an array with it being
 * the only item, if the value isn't already an array.
 *
 * @param  {*} value
 * @return {*[]}
 */
var toArray = exports.toArray = function toArray(value) {
  return Array.isArray(value) ? value : [value];
};

/**
 * Makes a moment sorter function to be passed into an array.
 *
 * @param  {String}   direction
 * asc or desc
 *
 * @param  {Function} getter
 * Invoked to get the moment on the element. Default is identity.
 *
 * @return {Function}
 * A function to pass into Array.prototype.sort
 */
var makeMomentSorter = exports.makeMomentSorter = function makeMomentSorter() {
  var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'asc';
  var getter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _identity2.default;
  return function (left, right) {
    var leftMoment = (0, _moment2.default)(getter(left));
    var rightMoment = (0, _moment2.default)(getter(right));

    var first = direction === 'asc' ? -1 : 1;
    var last = direction === 'asc' ? 1 : -1;

    if (leftMoment.isBefore(rightMoment)) return first;
    if (leftMoment.isAfter(rightMoment)) return last;

    return 0;
  };
};

/**
 * Like groupBy, but groups by whether the iteratee returns true or false.
 *
 * @param array
 * @param iteratee
 * @return
 * An array where the first item is the true array, and the second is the false array.
 * @example
 *    const [even, odd] = groupByBinary([1, 2, 3, 4], i => i % 2 === 0)
 *    even = [2, 4]
 *    odd = [1, 3]
 */
var groupByBinary = exports.groupByBinary = function groupByBinary(array, iteratee) {
  var trueItems = [];
  var falseItems = [];
  array.forEach(function (item) {
    if (iteratee(item)) {
      trueItems.push(item);
    } else {
      falseItems.push(item);
    }
  });

  return [trueItems, falseItems];
};
//# sourceMappingURL=arrayUtil.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@taxfyle/web-commons/lib/utils/arrayUtil.js
// module id = 154
// module chunks = 0